import Box from '@mui/material/Box';
import { Paper } from '@mui/material';

import ProductFilters from '../components/ProductFilters';
import ProductDashboard from '../ProductDashboard';
import { useAppContext } from './AppContext';
import Header from '../components/Header';
import Login from '../Login/Login';

export const AppContent = () => {
  const { isLoggedIn } = useAppContext();

  return (
    <Box
      sx={{
        backgroundColor: '#F1F3F2',
        minHeight: '90vh',
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Header />

      {!isLoggedIn ? (
        <Login />
      ) : (
        <>
          <ProductFilters />
          <Paper elevation={3} sx={{ width: '90%', bgcolor: 'white', paddingBottom: 0 }}>
            <ProductDashboard />
          </Paper>
        </>
      )}
    </Box>
  );
};
